import { render, staticRenderFns } from "./All-messages.vue?vue&type=template&id=535a824f&lang=html"
import script from "./All-messages.vue?vue&type=script&lang=js"
export * from "./All-messages.vue?vue&type=script&lang=js"
import style0 from "./All-messages.vue?vue&type=style&index=0&id=535a824f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports